import { PAMetricInfoSkeleton } from './PAMetricInfoSkeleton';
import { PAChartSkeleton } from './PAChartSkeleton';
import { BlockStack, Card } from '@shopify/polaris';

export const PADonutChartSkeleton = () => {
  return (
    <Card>
      <BlockStack gap="400">
        <PAMetricInfoSkeleton isShowOneLine />
        <PAChartSkeleton />
      </BlockStack>
    </Card>
  );
};
